export enum FontColor {
  PrimaryMain = 'primary-main',
  PrimaryLight = 'primary-light',
  PrimaryDark = 'primary-dark',
  SecondaryMain = 'secondary-main',
  SecondaryLight = 'secondary-light',
  SecondaryDark = 'secondary-dark',
  Error = 'error',
}

export enum FontSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  ExtraLarge = 'extra-large',
  ExtraExtraLarge = 'extra-extra-large',
}
